import Utils from 'common/scripts/utils';

export const convertToDigit = {
    methods: {
        convertToDigit(value) {
            return Utils.convertToDigit(value);
        }
    }
};
